export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";